export type ErrorDetails = {
    readonly code?: string
    readonly message?: string
}